module.exports = __webpack_public_path__ + "img/chemical-plastic-granules.fd8c004c.jpg";